import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SectionHeader } from "@/components/SectionHeader";
import { RevealStagger } from "@/components/Reveal";

gsap.registerPlugin(ScrollTrigger);

const steps = [
  { num: "1", title: "Vous nous appelez", text: "Un simple coup de fil ou un message via le formulaire. On échange sur votre projet." },
  { num: "2", title: "On vient chez vous", text: "Visite gratuite sur place pour évaluer précisément votre chantier. Aucun engagement." },
  { num: "3", title: "Devis clair sous 48h", text: "Un devis détaillé, transparent, sans surprise. Vous décidez ensuite." },
  { num: "4", title: "On réalise le chantier", text: "Aux dates convenues, avec un chantier propre du début à la fin." },
];

export const Method = () => {
  const lineRef = useRef(null);
  const sectionRef = useRef(null);

  useEffect(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.fromTo(
        lineRef.current,
        { clipPath: "inset(0 100% 0 0)" },
        {
          clipPath: "inset(0 0% 0 0)",
          ease: "none",
          scrollTrigger: { trigger: sectionRef.current, start: "top 70%", end: "bottom 60%", scrub: 0.6 },
        }
      );
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set(lineRef.current, { clipPath: "inset(0 0% 0 0)" });
    });
    return () => mm.revert();
  }, []);

  return (
    <section ref={sectionRef} className="py-16 lg:py-28 bg-brand-deep noise-overlay relative" data-testid="method-section">
      <div className="max-w-site mx-auto px-5 lg:px-6 relative">
        <SectionHeader label="Comment ça marche" title="De votre appel à votre façade neuve, en 4 étapes." dark />

        <div className="relative">
          {/* Ligne horizontale desktop */}
          <div className="hidden lg:block absolute top-7 left-[12.5%] right-[12.5%] h-[3px] bg-white/15 rounded-full" aria-hidden="true">
            <div ref={lineRef} className="h-full rounded-full" style={{ background: "var(--gradient-metal)", clipPath: "inset(0 100% 0 0)" }} />
          </div>

          <RevealStagger className="grid grid-cols-1 lg:grid-cols-4 gap-10 lg:gap-8" stagger={0.12}>
            {steps.map((s) => (
              <div key={s.num} className="relative flex lg:flex-col items-start lg:items-center gap-5 lg:gap-0 lg:text-center">
                <div
                  className="w-14 h-14 rounded-full bg-white flex items-center justify-center shrink-0 relative z-10"
                  style={{ border: "2px solid transparent", backgroundImage: "linear-gradient(#fff,#fff), var(--gradient-metal)", backgroundOrigin: "border-box", backgroundClip: "padding-box, border-box" }}
                >
                  <span className="font-heading font-bold text-xl text-brand-royal tnum">{s.num}</span>
                </div>
                <div className="lg:mt-6">
                  <h3 className="font-heading font-semibold text-xl text-white">{s.title}</h3>
                  <p className="mt-2 text-[15px] text-white/75 max-w-[260px] lg:mx-auto">{s.text}</p>
                </div>
              </div>
            ))}
          </RevealStagger>
        </div>
      </div>
    </section>
  );
};
